import { DataResult, DataSourceRequestState } from '@progress/kendo-data-query';
import { SpecificationDto } from 'src/store/specifications/specification';
import { ArrayUtils } from 'src/utils/array';
import { ApiError } from '../api-handler';
import {
  SpecificationAction,
  SpecificationTypes
} from './specifications.actions';

export type SpecificationsState = Readonly<{
  specifications: SpecificationDto[];
  filteredSpecifications: DataResult;
  errors: Nullable<ApiError>;
  requestState: DataSourceRequestState;
}>;

export const initialState: SpecificationsState = {
  specifications: [],
  filteredSpecifications: { data: [], total: 0 },
  errors: null,
  requestState: {
    skip: 0,
    take: 20,
    sort: [{ field: 'no', dir: 'desc' }]
  }
};

const specificationsReducer = (
  state: SpecificationsState = initialState,
  action: SpecificationAction
): SpecificationsState => {
  switch (action.type) {
    case SpecificationTypes.FetchAll:
      return { ...state, specifications: action.specifications };
    case SpecificationTypes.FetchFiltered:
      return {
        ...state,
        filteredSpecifications: action.filteredSpecifications
      };
    case SpecificationTypes.Delete:
      return {
        ...state,
        specifications: ArrayUtils.deleteFromListById(
          state.specifications,
          action.specification
        ),
        filteredSpecifications: {
          ...state.filteredSpecifications,
          data: ArrayUtils.deleteFromListById(
            state.filteredSpecifications.data,
            action.specification
          )
        }
      };
    case SpecificationTypes.Failure:
      return { ...state, errors: action.errors };
    case SpecificationTypes.UpdateRequestState:
      return { ...state, requestState: action.requestState };
    default:
      return state;
  }
};

export default specificationsReducer;
